import { getSelectedTableView } from 'owa-mail-list-store';
import { resetFocus } from 'owa-mail-focus-manager';
import type { ActionSource } from 'owa-mail-store';
import { lazyAddSafeSenderFromTable } from 'owa-mail-triage-action';
import getEffectiveRowKeys from 'owa-mail-list-store/lib/utils/getEffectiveRowKeys';

export default function onNeverBlock(
    actionSource: ActionSource,
    onNeverBlockCompleted?: (safeSenderAdded: boolean) => void
): void {
    const tableView = getSelectedTableView(true /*shouldGetEffectiveView*/);
    const rowKeys = getEffectiveRowKeys(tableView);

    lazyAddSafeSenderFromTable.importAndExecute(
        rowKeys,
        tableView,
        actionSource,
        undefined /* targetWindow */,
        onNeverBlockCompleted
    );
    resetFocus('neverBlockCommand');
}
